import { render, staticRenderFns } from "./SocialWallFeed.vue?vue&type=template&id=94de4f6e&scoped=true"
import script from "./SocialWallFeed.vue?vue&type=script&lang=js"
export * from "./SocialWallFeed.vue?vue&type=script&lang=js"
import style0 from "./SocialWallFeed.vue?vue&type=style&index=0&id=94de4f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94de4f6e",
  null
  
)

export default component.exports